/**
 * A Date's calendar day where the teacher is, as `YYYY-MM-DD`.
 *
 * `toISOString().split("T")[0]` is the obvious way to write this and is wrong:
 * it converts to UTC first, so an evening in the Americas and a morning in
 * Asia both report the neighbouring day. That is how a week-of column can name
 * one Monday while the request asks for another.
 */
export const localIsoDate = (date) => {
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${date.getFullYear()}-${month}-${day}`;
};
